import { useForm } from 'react-hook-form';
import Button from '../Reusable/Button';
import ComboboxInput from './ComboboxInput';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useTicketServiceGetHook';
import usePatchHook from '../../customHooks/useTicketServicePatchHook';

const ChangeStatus = (props: any) => {
  const { selectedId, setOpenStatusChangePopup } = props

  const { refetch } = useGetHook({
    queryKey: [`ticket-${selectedId}`],
    url: `${APIS.TICKET}${selectedId}/`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    defaultValues: async () => {
      let data: any = await refetch()
      return {
        ...data?.data,
      }
    }
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["ticket"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.TICKET}${selectedId}/`;
    let formData = {
      resolution: values?.resolution,
      status: values?.status
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        setOpenStatusChangePopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form onSubmit={handleSubmit((data: any) => handleEdit(data, setError))} autoComplete="off">
      <ComboboxInput
        url={`${APIS.TICKET}available-status/`}
        queryKey={"status"}
        register={register("status")}
        errors={errors?.parent}
        name={"status"}
        label={"Status"}
        setValue={setValue}
        placeholder={"Search Status"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className='h-2'></div>
      <label htmlFor="resolution">Reply</label>
      <textarea id="resolution" rows={6}
        {...register("resolution")}
        className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
        placeholder="Write a comment..." required></textarea>
      <div className="flex justify-end w-full">
        <div className="w-[150px] mr-4">
          <Button label={"Update"} isLoading={isPatchLoading} />
        </div>
      </div>
    </form>
  )
}

export default ChangeStatus
